import * as GroupType from 'constants/GroupType';

const BASKETBALL_GROUP_MAP = {};

BASKETBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
BASKETBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
BASKETBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
BASKETBALL_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
BASKETBALL_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;
BASKETBALL_GROUP_MAP[5] = GroupType.BASKETBALL_MATCH_TWO_POINTS_GROUP;
BASKETBALL_GROUP_MAP[6] = GroupType.BASKETBALL_MATCH_THREE_POINTS_GROUP;
BASKETBALL_GROUP_MAP[7] = GroupType.FIRST_HALF_GROUP;
BASKETBALL_GROUP_MAP[8] = GroupType.SECOND_HALF_GROUP;

export default BASKETBALL_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Basketball/GroupMap.js